import React from 'react';

const Table = ({
  columns,
  data,
  loading = false,
  emptyMessage = 'No data available',
  onSort,
  sortColumn,
  sortDirection,
  actions,
}) => {
  const handleSort = (column) => {
    if (onSort && column.sortable) {
      onSort(column.key);
    }
  };
  //console.log(data);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
  <tr>
    {columns.map((column, index) => (
      <th
        key={index}
        scope="col"
        className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${
          column.sortable ? 'cursor-pointer hover:bg-gray-100' : ''
        }`}
        onClick={() => handleSort(column)}
      >
        <div className="flex items-center space-x-1">
          <span>{column.title}</span>
        </div>
      </th>
    ))}

    {actions && (
      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
        Actions
      </th>
    )}
  </tr>
</thead>
        <tbody className="bg-white divide-y divide-gray-200">
  {data.length > 0 ? (
    data.map((row, rowIndex) => (
      <tr key={rowIndex} className="hover:bg-gray-50">

        {/* Data Columns */}
       {columns.map((column, colIndex) => {
  const value =
    typeof column.key === 'function'
      ? column.key(row)
      : row[column.key];

  return (
    <td key={colIndex} className="px-6 py-4 whitespace-nowrap">
      {column.render
        ? column.render(value, row)
        : (value ?? '-')}
    </td>
  );
})}

        {/* Actions Column */}
        {actions && (
          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            {actions(row)}
          </td>
        )}

      </tr>
    ))
  ) : (
    <tr>
      <td
        colSpan={columns.length + (actions ? 1 : 0)}
        className="px-6 py-4 text-center text-sm text-gray-500"
      >
        {emptyMessage}
      </td>
    </tr>
  )}
</tbody>
      </table>
    </div>
  );
};

export default Table;